// Tiny one-shot canvas confetti — draws colored streaks outward from a screen point
// for ~1200ms. Cleans itself up. Used on skin unlocks and milestone claims.

export function fireConfetti({ x, y, color = "#F0ABFC", glow = "rgba(240,171,252,0.75)", count = 60, duration = 1200 } = {}) {
  if (typeof window === "undefined") return;
  const canvas = document.createElement("canvas");
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  Object.assign(canvas.style, {
    position: "fixed",
    left: "0",
    top: "0",
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: "9999",
  });
  document.body.appendChild(canvas);
  const ctx = canvas.getContext("2d");
  const cx = x ?? canvas.width / 2;
  const cy = y ?? canvas.height / 2;
  const palette = [color, glow.replace(/[\d.]+\)$/, "0.9)"), "#FFD400", "#39FF14", "#00F0FF", "#FF0055"];
  const particles = Array.from({ length: count }).map(() => {
    const angle = Math.random() * Math.PI * 2;
    const speed = 4 + Math.random() * 8;
    return {
      x: cx, y: cy,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed - Math.random() * 4,
      life: 1,
      size: 2 + Math.random() * 3,
      color: palette[(Math.random() * palette.length) | 0],
    };
  });
  const start = performance.now();
  const tick = (now) => {
    const t = now - start;
    const dt = 1 / 60;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (const p of particles) {
      p.vy += 0.35;                    // gravity
      p.vx *= 0.985;
      p.x += p.vx;
      p.y += p.vy;
      p.life = Math.max(0, 1 - t / duration);
      ctx.globalAlpha = p.life;
      ctx.fillStyle = p.color;
      ctx.shadowBlur = 8;
      ctx.shadowColor = p.color;
      ctx.fillRect(p.x - p.size / 2, p.y - p.size / 2, p.size, p.size);
    }
    ctx.shadowBlur = 0;
    ctx.globalAlpha = 1;
    if (t < duration) {
      requestAnimationFrame(tick);
    } else {
      canvas.remove();
    }
  };
  requestAnimationFrame(tick);
}
